export default __webpack_public_path__ + "static/media/_logo_card_maestro.b4bdb64b.svg";